import React from 'react';
import Svg, { Path, Circle } from 'react-native-svg';

// Info icon component
export const InfoIcon = () => (
  <Svg width={16} height={16} viewBox="0 0 16 16" fill="none">
    <Path d="M7.33333 4.66667H8.66667V6H7.33333V4.66667ZM7.33333 7.33333H8.66667V11.3333H7.33333V7.33333ZM8 1.33333C4.32 1.33333 1.33333 4.32 1.33333 8C1.33333 11.68 4.32 14.6667 8 14.6667C11.68 14.6667 14.6667 11.68 14.6667 8C14.6667 4.32 11.68 1.33333 8 1.33333ZM8 13.3333C5.06 13.3333 2.66667 10.94 2.66667 8C2.66667 5.06 5.06 2.66667 8 2.66667C10.94 2.66667 13.3333 5.06 13.3333 8C13.3333 10.94 10.94 13.3333 8 13.3333Z" fill="#FFFFFF" />
  </Svg>
);

// Radio button component
export const RadioButton = ({ selected, color = '#FFFFFF' }: { selected: boolean; color?: string }) => (
  <Svg width={16} height={24} viewBox="0 0 16 24" fill="none">
    {selected ? (
      <>
        <Path d="M8 16.6667C10.5773 16.6667 12.6667 14.5775 12.6667 12C12.6667 9.42253 10.5773 7.33333 8 7.33333C5.42269 7.33333 3.33333 9.42253 3.33333 12C3.33333 14.5775 5.42269 16.6667 8 16.6667Z" fill={color} />
        <Path fillRule="evenodd" clipRule="evenodd" d="M16 12C16 16.418 12.4183 20 8 20C3.58171 20 0 16.418 0 12C0 7.58203 3.58171 4 8 4C12.4183 4 16 7.58203 16 12ZM14.6667 12C14.6667 15.6816 11.682 18.6667 8 18.6667C4.31803 18.6667 1.33333 15.6816 1.33333 12C1.33333 8.31836 4.31803 5.33333 8 5.33333C11.682 5.33333 14.6667 8.31836 14.6667 12Z" fill={color} />
      </>
    ) : (
      <Path fillRule="evenodd" clipRule="evenodd" d="M16 12C16 16.418 12.4183 20 8 20C3.58171 20 0 16.418 0 12C0 7.58203 3.58171 4 8 4C12.4183 4 16 7.58203 16 12ZM14.6667 12C14.6667 15.6816 11.682 18.6667 8 18.6667C4.31803 18.6667 1.33333 15.6816 1.33333 12C1.33333 8.31836 4.31803 5.33333 8 5.33333C11.682 5.33333 14.6667 8.31836 14.6667 12Z" fill={color} />
    )}
  </Svg>
);

// Back icon component
export const BackIcon = (props: { color?: string }) => (
  <Svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <Path d="M16 7H3.83L9.42 1.41L8 0L0 8L8 16L9.41 14.59L3.83 9H16V7Z" fill={props.color || "#004895"} />
  </Svg>
);

// Save icon component
export const SaveIcon = (props: { color?: string }) => (
  <Svg width="18" height="18" viewBox="0 0 18 18" fill="none">
    <Path d="M14 0H2C0.89 0 0 0.9 0 2V16C0 17.1 0.89 18 2 18H16C17.1 18 18 17.1 18 16V4L14 0ZM16 16H2V2H13.17L16 4.83V16ZM9 9C7.34 9 6 10.34 6 12C6 13.66 7.34 15 9 15C10.66 15 12 13.66 12 12C12 10.34 10.66 9 9 9ZM3 3H12V7H3V3Z" fill={props.color || "#004895"} />
  </Svg>
);

// Forward icon component
export const ForwardIcon = (props: { color?: string }) => (
  <Svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <Path d="M8 0L6.59 1.41L12.17 7H0V9H12.17L6.59 14.59L8 16L16 8L8 0Z" fill={props.color || "#ABABAB"} />
  </Svg>
);

// Down arrow icon component
export const DownArrowIcon = () => (
  <Svg width="16.667" height="8.333" viewBox="0 0 17 9" fill="none">
    <Path d="M0 0L8.33333 8.33333L16.6667 0H0Z" fill="#2D2D2D" />
  </Svg>
);

// Print icon component
export const PrintIcon = () => (
  <Svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <Path d="M12.6666 5.33333H11.9999V2H3.99992V5.33333H3.33325C2.22659 5.33333 1.33325 6.22667 1.33325 7.33333V11.3333H3.99992V14H11.9999V11.3333H14.6666V7.33333C14.6666 6.22667 13.7733 5.33333 12.6666 5.33333ZM5.33325 3.33333H10.6666V5.33333H5.33325V3.33333ZM10.6666 12.6667H5.33325V10H10.6666V12.6667ZM11.9999 10V8.66667H3.99992V10H2.66659V7.33333C2.66659 6.96667 2.96659 6.66667 3.33325 6.66667H12.6666C13.0333 6.66667 13.3333 6.96667 13.3333 7.33333V10H11.9999Z" fill="#034895" />
    <Path d="M11.9999 8.33333C12.3681 8.33333 12.6666 8.03486 12.6666 7.66667C12.6666 7.29848 12.3681 7 11.9999 7C11.6317 7 11.3333 7.29848 11.3333 7.66667C11.3333 8.03486 11.6317 8.33333 11.9999 8.33333Z" fill="#004895" />
  </Svg>
);

// Star icon outline component
export const StarIconOutline = () => (
  <Svg width="40" height="38" viewBox="0 0 40 38" fill="none">
    <Path d="M40 14.48L25.62 13.24L20 0L14.38 13.26L0 14.48L10.92 23.94L7.64 38L20 30.54L32.36 38L29.1 23.94L40 14.48ZM20 26.8L12.48 31.34L14.48 22.78L7.84 17.02L16.6 16.26L20 8.2L23.42 16.28L32.18 17.04L25.54 22.8L27.54 31.36L20 26.8Z" fill="#3A3A3A" />
  </Svg>
);

// News icon component
export const NewsIcon = () => (
  <Svg width="14" height="18" viewBox="0 0 14 18" fill="none">
    <Path d="M9.12 7.47L7 9.59L4.87 7.47L3.46 8.88L5.59 11L3.47 13.12L4.88 14.53L7 12.41L9.12 14.53L10.53 13.12L8.41 11L10.53 8.88L9.12 7.47ZM10.5 1L9.5 0H4.5L3.5 1H0V3H14V1H10.5ZM1 16C1 17.1 1.9 18 3 18H11C12.1 18 13 17.1 13 16V4H1V16ZM3 6H11V16H3V6Z" fill="#034895" />
  </Svg>
);

// Plus icon component
export const PlusIcon = () => (
  <Svg width="12" height="12" viewBox="0 0 12 12" fill="none">
    <Path d="M11.6667 6.66667H6.66667V11.6667H5V6.66667H0V5H5V0H6.66667V5H11.6667V6.66667Z" fill="#005CBC" />
  </Svg>
);

// Submit icon component
export const SubmitIcon = () => (
  <Svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <Path d="M4.01 6.03L11.52 9.25L4 8.25L4.01 6.03ZM11.51 14.75L4 17.97V15.75L11.51 14.75ZM2.01 3L2 10L17 12L2 14L2.01 21L23 12L2.01 3Z" fill="white" />
  </Svg>
);

// Complete icon component - circle with checkmark
export const CompleteIcon = () => (
  <Svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <Circle cx="12" cy="12" r="11" fill="none" stroke="white" strokeWidth="2" />
    <Path d="M7 12.5L10.5 16L17 8" stroke="white" strokeWidth="2.5" fill="none" strokeLinecap="round" strokeLinejoin="round" />
  </Svg>
);


export const FavouriteStarIcon = ({ filled = false }: { filled?: boolean }) => (
  <Svg width="14" height="13" viewBox="0 0 14 13" fill="none">
    {filled ? (
      <Path
        d="M8.54 4.41333L13.3333 4.82667L9.7 7.98L10.7867 12.6667L6.66667 10.18L2.54667 12.6667L3.64 7.98L0 4.82667L4.79333 4.42L6.66667 0L8.54 4.41333Z"
        fill="#3A3A3A"
      />
    ) : (
      <Path
        d="M8.54 4.41333L13.3333 4.82667L9.7 7.98L10.7867 12.6667L6.66667 10.18L2.54667 12.6667L3.64 7.98L0 4.82667L4.79333 4.42L6.66667 0L8.54 4.41333Z"
        fill="none"
        stroke="#616161"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    )}
  </Svg>
);